import { createFileRoute, Outlet } from "@tanstack/react-router";

/** Layout route: /koszyki/* — the index child redirects to the first open basket. */
export const Route = createFileRoute("/koszyki")({
  component: Outlet,
});
